// Helpers shared between the BD dashboard page and the BD Lassie page.

export const formatValue = (value) => {
  if (typeof value === "number") {
    return value;
  }
  if (value === null || value === undefined || value === "") {
    return "—";
  }
  return String(value);
};

// Chart text sizes follow the same wall-display scale as --bd-scale in the CSS.
export const chartFont = (px) => {
  const width = typeof window === "undefined" ? 0 : window.innerWidth;
  if (width >= 2400) return Math.round(px * 1.5);
  return px;
};

export const formatDateTime = (value) => {
  if (!value) return "—";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return String(value);
  return parsed.toISOString().slice(0, 16).replace("T", " ");
};

// Anonymization for the Lassie views. Labels are handed out first-come and
// remembered for the session, so "Client 3" stays the same client across
// refetches, re-sorts and tabs. Real names stay in the API responses.
const anonymousLabels = { windfarm: new Map(), client: new Map() };

const anonymousLabel = (kind, prefix, key) => {
  const registry = anonymousLabels[kind];
  if (!registry.has(key)) registry.set(key, `${prefix} ${registry.size + 1}`);
  return registry.get(key);
};

const clientLabel = (name) => {
  const key = typeof name === "string" ? name.trim().toLowerCase() : "";
  return key ? anonymousLabel("client", "Client", key) : name;
};

// Masks windfarm and client names on one row (a windfarm, lead or access row).
export const anonymizeRow = (row) => {
  if (!row) return row;
  const farmKey = row.windfarm_id ?? row.windfarm_name?.trim().toLowerCase();
  return {
    ...row,
    windfarm_name:
      farmKey === undefined || farmKey === null || farmKey === ""
        ? row.windfarm_name
        : anonymousLabel("windfarm", "Wind Farm", farmKey),
    customer: clientLabel(row.customer),
    owner: clientLabel(row.owner),
  };
};

export const anonymizeRows = (rows) => rows.map(anonymizeRow);

export const escapeCsvCell =(value) => {
  if (value === null || value === undefined) return "";
  const asString = String(value);
  if (/[",\n]/.test(asString)) {
    return `"${asString.replace(/"/g, '""')}"`;
  }
  return asString;
};

export const buildCsvContent = (rows) =>
  rows.map((row) => row.map(escapeCsvCell).join(",")).join("\n");

export const downloadCsvFile = (filename, rows) => {
  if (!Array.isArray(rows) || rows.length === 0) return;
  const csvContent = buildCsvContent(rows);
  const blob = new Blob([csvContent], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
};
